import { NgModule } from "@angular/core";
import { ReservationLogsComponent } from "./reservation-logs.component";
import { ReservationLogsRoutingModule } from "./reservation-logs-routing.module";
import { MatToolbarModule } from "@angular/material/toolbar"; // Fixed import
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { MatTableModule } from "@angular/material/table";
import { TruncateModule } from "@pipes/truncate/truncate.module";
import { MatIconModule } from "@angular/material/icon";
import { WsTooltipModule } from "@web/util/ws-ui/ws-tooltip/ws-tooltip.module";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [ReservationLogsComponent],
    imports: [
        ReservationLogsRoutingModule,
        MatToolbarModule,
        TranslateModule,
        MatInputModule,
        FormsModule,
        MatTableModule,
        TruncateModule,
        MatIconModule,
        WsTooltipModule,
        CommonModule
    ],
    exports: [
        ReservationLogsComponent
    ]
})
export class ReservationLogsModule { }